import { BodyText } from '@/utils/global-fonts';
import styled from 'styled-components';
import { IoMdClose } from 'react-icons/io';
import { BsFileRichtext } from 'react-icons/bs';
import { Col } from '@/components/grid/grid-component';

const DocumentUploadAction = styled.div`
  display: flex;
  justify-content: flex-start;
  align-content: center;
  align-items: center;
  gap: 8px;
  width: auto;
  cursor: pointer;
`;
const ActionText = styled(BodyText)`
  font-family: Inter;
  font-size: 14px;
  font-weight: 600;
  line-height: 24px;
  letter-spacing: 0.2px;
  text-align: left;
  text-vertical-align: middle;
`;

const FileListWrapper = styled.ul`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
  padding: 0;
`;
const FileItem = styled.li`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  list-style: none;
  padding: 0;
  margin: 0;
  padding-inline-start: 1px;
`;

const FileName = styled.span`
  width: 75%;
  display: flex;
  flex-direction: column;
  font-size: 14px;
  line-height: 16px;
`;

const FileLabel = styled.span`
  flex: 1;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`;

const FileSize = styled.span`
  font-size: 12px;
  color: ${({ theme }) => theme.COLOR_GREY3};
`;

const StyledCloseIcon = styled(IoMdClose)`
  font-size: 14px;
  color: ${({ theme }) => theme.COLOR_GREY3};
  cursor: pointer;
`;

const FileIconContainer = styled.span`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 40px;
  height: 40px;
  border-radius: 4px;
  background-color: ${({ theme }) => theme.COLOR_GREY};
`;
const StyledFileIcon = styled(BsFileRichtext)`
  font-size: 24px;
  color: ${({ theme }) => theme.COLOR_GREY3};
  cursor: pointer;
`;

const StyledButtonCol = styled(Col)`
  display: flex;
  align-items: center;
`;
const StyledDocumentUpload = {
  DocumentUploadAction,
  ActionText,
  FileListWrapper,
  FileItem,
  FileName,
  FileSize,
  FileLabel,
  StyledCloseIcon,
  StyledFileIcon,
  FileIconContainer,
  StyledButtonCol,
};

export default StyledDocumentUpload;
